import React from "react";
import { cn } from "../../../common/u1/cn";
import { Button } from "../../../common/u1/Button";
import { PlanCard } from "./PlanCard";
import { LockIcon } from "../../../../assets/ui/icons";

/* Choose a billing cycle, then commit — the design's `.mem-become`, `.plan-grid` and `.mem-cta`. */
export const PlanSelector = ({
  plans = [],
  value,
  onChange = () => {},
  onSubmit = () => {},
  title = "Become a member",
  note = "Cancel anytime · billed in AED",
  ctaLabel = "Become a Member",
  reassurance = "Secure checkout · invoice issued instantly",
  className = "",
}) => (
  <section className={cn(className)}>
    <div className="mt-6 mb-4 flex flex-wrap items-baseline justify-between gap-2">
      <h3 className="m-0 text-[18px] font-bold text-[var(--ink)] font-sans">{title}</h3>
      {note && <span className="text-[13px] text-[var(--muted)] font-sans">{note}</span>}
    </div>

    <div role="radiogroup" aria-label={title} className="grid grid-cols-1 gap-4 md:grid-cols-2">
      {plans.map((plan) => (
        <PlanCard
          key={plan.id}
          id={plan.id}
          name="membership-plan"
          label={plan.label}
          price={plan.price}
          unit={plan.unit}
          note={plan.note}
          footnote={plan.footnote}
          footnoteTone={plan.footnoteTone}
          ribbon={plan.ribbon}
          selected={value === plan.id}
          onSelect={onChange}
        />
      ))}
    </div>

    <div className="mt-[22px] flex flex-wrap items-center gap-[18px]">
      <Button
        variant="coralSolid"
        onClick={onSubmit}
        className="h-auto rounded-xl px-[26px] py-3.5 text-[15px] font-bold"
      >
        {ctaLabel}
      </Button>
      {reassurance && (
        <span className="flex items-center gap-[7px] text-[12.5px] text-[var(--muted-2)] font-sans">
          <LockIcon size={15} />
          {reassurance}
        </span>
      )}
    </div>
  </section>
);

export default PlanSelector;
